import { EUnavailableReasonType } from '../../../../../../repositories/billing-tariffs/entities/PublishTerms/Moderation';
import { ERestrictionType } from '../../../../../../reducers/v2';

export function mapRestrictionType(unavailableReasonType: EUnavailableReasonType): ERestrictionType {
  switch (unavailableReasonType) {
    case EUnavailableReasonType.DeniedBySanctions:
      return ERestrictionType.DeniedBySanctions;
    case EUnavailableReasonType.SubAgentLimitExceeded:
      return ERestrictionType.SubAgentLimitExceeded;
    default:
      return ERestrictionType.DeniedBySanctions;
  }
}
